import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { WorkflowService } from "../workflow.service";
import { WorkflowStep } from "../workflow-step";
import { WorkflowStepStatus } from "../models/workflow-step-status.enum";
import { ProjectService } from "../../project/project.service";
import { handleErrors } from "../../misc/handle-errors.decorator";
import { shippingLabelPlaceholders } from "../../types/shipping-label-placeholders";
import { AppSettingsService } from "../../app-settings/app-settings.service";
import { HasuraGraphqlService } from "../../graphql/hasura-graphql-service";

@Component({
  templateUrl: "./edit-shipping-labels.template.pug",
  providers: [
    ProjectService,
    HasuraGraphqlService
  ],
})
export class EditShippingLabelsComponent extends WorkflowStep {
  currentFocus: string = "shippingLabel1";
  error: Error;

  shippingLabel1: string;
  shippingLabel2: string;
  originalShippingLabel1: string;
  originalShippingLabel2: string;
  isMpc: boolean;
  currentMaStatus: string;

  placeholders: any[] = [];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public projectService: ProjectService,
    private appSettingsService: AppSettingsService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super();
    this.placeholders = shippingLabelPlaceholders
      .filter(it =>
        (!it.disabledTargetSystems || !it.disabledTargetSystems[this.workflowService.workflowConfig.targetSystem]));
  }

  async ready() {
    this.loading = true;
    this.loadProjectInfo();
    this.loading = false;
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.projectService.saveShippingLabels(
      this.workflowTargetInfo.projectId,
      this.shippingLabel1,
      this.shippingLabel2,
    );

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  async loadProjectInfo() {
    let enableApolloProjectQuery = await this.appSettingsService.getFeaturePermission(
      "enableApolloProjectQuery",
      this.workflowTargetInfo.projectId,
    );

    /*let params: any = `
      id
      customShippingLabel1
      customShippingLabel2
      isMpc
      currentMaStatus`;
    const {
      shippingLabel1,
      shippingLabel2,
      isMpc,
      currentMaStatus
    } = enableApolloProjectQuery ? await this.projectService.getProjectDetails(this.workflowTargetInfo.projectId, params) :
        await this.projectService.getProjectById(this.workflowTargetInfo.projectId).toPromise();*/

    const params: any = `
        id
        customShippingLabel1: custom_label_1
        customShippingLabel2: custom_label_2
        isMpc: is_mpc
        currentMaStatus: cur_master_agreement_status`;
    const resp = await this.hasuraGqlService.getProjectResponseFromHasura(this.workflowTargetInfo.projectId, params);
    const {
      shippingLabel1,
      shippingLabel2,
      isMpc,
      currentMaStatus,
    } = resp;
    this.shippingLabel1 = shippingLabel1;
    this.shippingLabel2 = shippingLabel2;
    this.originalShippingLabel1 = shippingLabel1;
    this.originalShippingLabel2 = shippingLabel2;
    this.isMpc = isMpc;
    this.currentMaStatus = currentMaStatus;
  }

  checkDirty(): boolean {
    if (this.isMpc && this.currentMaStatus === "MA not sent") {
      return true;
    }
    return !(this.shippingLabel1 === this.originalShippingLabel1) ||
      !(this.shippingLabel2 === this.originalShippingLabel2);
  }

  addPlaceholder(placeholder) {
    if (this.currentFocus === "shippingLabel1") {
      this.shippingLabel1 = `${this.shippingLabel1 || ""}${placeholder}`;
    } else if (this.currentFocus === "shippingLabel2") {
      this.shippingLabel2 = `${this.shippingLabel2 || ""}${placeholder}`;
    }
  }

  onFocus(parameter) {
    this.currentFocus = parameter;
  }
}
